import React, { useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import UseWindowDimensions from "../../../utils/windowSize";
import { setError404 } from "../../../redux/features/settingSlice";
import CustomButton from "../CustomButton";
import { useNavigate } from "react-router";
import CustomHelmet from "./../CustomHelmet/index";
import { getPlayerState } from "../../../redux/features/playerSlice";
import logoType from "../../../media/svg/logo-type.svg";
import logoIcon from "../../../media/svg/logo-slim-icon.svg";

const Error404Page = () => {
  const { height } = UseWindowDimensions();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { minimizePlayer } = useSelector(getPlayerState);

  useEffect(() => {
    dispatch(setError404(true));
    return () => {
      dispatch(setError404(false));
    };
  }, [dispatch]);

  return (
    <>
      <CustomHelmet title={`Error 404 | Azad`} />
      <Box
        sx={{
          display: "flex",
          height: height - 62 - (minimizePlayer ? 82 : 0) + "px",
          alignItems: "end",
          backgroundColor: "white.main",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Box sx={{ px: "16px", mt: "40px", textAlign: "center" }}>
            <Box
              sx={{
                padding: "16px 0 10px 0",
                display: "flex",
                flexDirection: "column",
                mb: "10px",
                alignItems: "center",
              }}
            >
              <img
                src={logoIcon}
                alt='Azad Logo Icon'
                width='100px'
                height='100px'
              />
              <img
                style={{ marginTop: "15px" }}
                src={logoType}
                alt='Azad Logo Name'
                width='130px'
                height='38px'
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "24px 16px 16px 16px",
              mt: "auto",
              mb: "40px",
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontFamily: "Tahrir",
                fontSize: "40px",
                lineHeight: "40px",
              }}
            >
              Sorry, we can't find the page you are looking for. (Error 404)
            </Typography>

            <Typography
              sx={{
                display: "inline-block",
                fontSize: "18px",
                lineHeight: "28px",
                mt: "25px",
                mb: "15px",
              }}
            >
              We suggest going back to our or
              <Typography
                component={"span"}
                sx={{
                  fontWeight: 600,
                  display: "inline-block",
                  px: "3px",
                  fontSize: "18px",
                }}
              >
                home page
              </Typography>
              or
              <Typography
                component={"span"}
                sx={{
                  fontWeight: 600,
                  display: "inline-block",
                  px: "3px",
                  fontSize: "18px",
                }}
              >
                explore page
              </Typography>
              to find what you need.
            </Typography>

            <Box sx={{ display: "flex", mt: "16px" }}>
              <CustomButton
                title='Home Page'
                onClick={() => navigate("/")}
                fSize='16px'
                width='100%'
                height='48px'
                bShadow='0px'
                bgColor='white.main'
                mRight='16px'
              />

              <CustomButton
                title='Explore'
                onClick={() => navigate("/explore")}
                fSize='16px'
                width='100%'
                height='48px'
                bShadow='4px'
                bgColor='primary.main'
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Error404Page;
